export default {
  ClassName: {
    IMAGE: 'spark-responsive-img',
    LOADED: 'spark-responsive-img--loaded',
  },
};
